import { render, staticRenderFns } from "./TableFooter.vue?vue&type=template&id=94b99722&scoped=true&"
import script from "./TableFooter.vue?vue&type=script&lang=ts&"
export * from "./TableFooter.vue?vue&type=script&lang=ts&"
import style0 from "./TableFooter.vue?vue&type=style&index=0&id=94b99722&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94b99722",
  null
  
)

export default component.exports